import React from 'react';
import { Col } from 'antd';
import { TableDes, TableRow, TableView } from './POSummaryStyle';

const POSummary = ({ overallTotal = {}, productPackage = false }) => {
  return (
    <TableView
    //   style={{
    //     width: 300,
    //     padding: 10,
    //     borderRadius: 10,
    //     border: '1px solid #d9d9d9',
    //     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    //   }}
    >
      <TableRow>
        <Col span={16}>
          <TableDes>Sub Total</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{overallTotal.subTotal}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes>Discount</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{overallTotal.discount}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes>IGST</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{overallTotal.igstAmount}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes>SGST</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{overallTotal.sgstAmount}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes>CGST</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{overallTotal.cgstAmount}</TableDes>
        </Col>
      </TableRow>
      {!productPackage && (
        <TableRow>
          <Col span={16}>
            <TableDes>Shipping</TableDes>
          </Col>
          <Col span={8} style={{ textAlign: 'right' }}>
            <TableDes>{overallTotal.shipping}</TableDes>
          </Col>
        </TableRow>
      )}
      <TableRow>
        <Col span={16}>
          <TableDes style={{ color: '#1890ff', fontWeight: 'bold' }}>Grand Total</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes style={{ color: '#1890ff', fontWeight: 'bold' }}>{overallTotal.grandTotal}</TableDes>
        </Col>
      </TableRow>
    </TableView>
  );
};

export default POSummary;
